import { useFlags } from "launchdarkly-react-client-sdk";

export const useFeatureFlag = (
  flagKey: string,
  defaultValue: boolean = false
): boolean => {
  const flags = useFlags();
  return flags[flagKey] ?? defaultValue;
};
